<template>
  <div id="app">
					<div class="text">
            <div class="container">
            <hr>
            <h3>Prehľad za obdobie {{this.start | moment("DD/MM/YYYY")}} až {{this.end | moment("DD/MM/YYYY")}}</h3>
            <div class="row">
  

</div>
<hr>

</div>


					</div>
          <div class="container" v-for="user in []" :key="user.id">
  <h2>{{user.firstname}} {{user.lastname}}</h2>            
  
  <table class="table table-striped" style="text-align:left">
    <thead style="text-align:left">
      <tr style="text-align:left">
        <th>Projekt</th>
        <th>Čas</th>
        <th>Prestávky</th>
        <th>Najazdené km</th>

      </tr>
    </thead>
    <tbody>
      <tr v-for="p in user.projects" :key="p.id">
        <td>{{p.name}}</td>
        <td>{{p.total}}</td>
        <td>{{p.totalBreaksHours}}</td>
        <td>{{p.totalKm}}</td>
      </tr>

    </tbody>
  </table>
<!--<p><b>Spolu odpracované:</b> {{user.totalHours}}  | sec: {{user.totalSecondsWithoutBreaks}} | break: {{totalBreaksSeconds}}</p>
<p><b>Spolu najazdených:</b> {{user.totalKm}} km</p>-->
<hr>
<br>
</div>

  </div>
</template>

<script>
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'
import firebase from 'firebase'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import Vue from 'vue';

export default {
  components : {
    Datepicker
  },
  name: 'Tracker',
  data() {
    return {
      project : "",
      totalBreaksSeconds : 0,
      projects : [],
      start : null,
      end : null,
      dateFrom : '',
      dateTo : '',
      user : '',
      result : [],
      total : 0,
      totalKm : 0,
      summary : {
        users : []
      }
    }
  },
  methods : {
    secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hodina, " : " hodín, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minúta, " : " minút, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sekunda" : " sekúnd") : "";
    return hDisplay + mDisplay + sDisplay; 
},
    async getUsers()
    {
      await firebase.firestore().collection('user').get().then(snap => {
        if(!snap.empty)
        {
          snap.docs.forEach(doc => {
            
              this.summary.users = snap.docs.map(x => x.data());

          });
        }
      });
    },
    async getSummary()
    {
      await this.getUsers();
      await this.summary.users.forEach(async user => {
      //          user.projects = [];
      
        var userTime = 0;

        await firebase.firestore().collection('project').get().then(async projects => {
          
          //user.projects = [];
            Vue.set(user, 'projects', projects.docs.map(x=>x.data()));
            Vue.set(user, 'totalSeconds', parseInt(1));
            Vue.set(user, 'totalHours', "");
            Vue.set(user, 'totalKm', 0);
            Vue.set(user, 'totalSecondsWithoutBreaks', parseInt(1));

            

          await user.projects.forEach(async p => {
            var start = moment().subtract(1, 'months').startOf('month').toDate();
            var end = moment().subtract(1, 'months').endOf('month').toDate();
                      
            
            await firebase.firestore().collection('timer').where('email', '==', user.email).where('project', '==', p.name).
            where('begin', '>', start).where('begin', '<', end).get().then(async data => {
              
              if(!data.empty)
              {
                var totalSeconds = 0;
                var totalKm = 0;

                data.forEach(y => {
                  var s = y.data().end - y.data().begin;
                if(user.email == 'maria.bukorova@dajsipauzu.sk')
                {
                  console.log("worked " + s + " seconds on " + y.data().begin.toDate());
                }
                  totalSeconds += s;
                  user.totalSeconds += s;
                  user.totalSecondsWithoutBreaks += s;
                  console.log("adding " + s + " to " + user.totalSecondsWithoutBreaks);
                  var pkm = y.data().end_km - y.data().start_km;
                  if(Number.isInteger(pkm))
                  {
                    totalKm += y.data().end_km - y.data().start_km;
                    user.totalKm += totalKm;
                  }
              });
                                  if(user.email == 'maria.bukorova@dajsipauzu.sk')
                                  {
                                            console.log("worked TOTAL " + user.totalSeconds + " seconds");

                                  }
              //var convertedDate = moment().seconds(totalSeconds).format("h");
              
                var breaks = Math.floor(totalSeconds / 21600);
                var bseconds = 0;
                if(user.email == 'maria.bukorova@dajsipauzu.sk')
                {

                  console.log("breaks for this seession: " + (breaks) + " on ");
                }
                
                if(breaks > 0)
                {
                    totalSeconds -= 1800 * breaks;
                    user.totalSeconds -= 1800 * breaks;
                    this.totalBreaksSeconds += breaks * 1800;
                    Vue.set(p, "totalBreaksSeconds", breaks * 1800);
                    Vue.set(p, "totalBreaksHours", this.secondsToHms(breaks * 1800));

                }
              
              Vue.set(p, 'total', this.secondsToHms(totalSeconds));
              Vue.set(p, 'totalKm', (totalKm));

              
              }
              
              //project.data().total = 666159;
            });
            Vue.set(user, 'totalHours', this.secondsToHms(user.totalSeconds));
          });



        });
            //Vue.set(user, 'totalHours', )
      });
      

    },
    async getProjects()
    {
            await firebase.firestore().collection('project').get().then(snap => {
        if(!snap.empty)
        {
          console.log("snap not empty");
          this.projects = snap.docs.map(x => x.data());
        }
        });
    },
    dateChange()
    {
      console.log("wat");
      console.log(this.dateFrom);
    },
    async load()
    {
      console.log("loading");
            await firebase.firestore().collection('timer').where('begin', '>', this.dateFrom).where('begin', '<', this.dateTo).where('email', '==', this.user).where("project", '==', this.project).get().then(snap => {
              console.log("length " + snap.docs.length);
              this.result = snap.docs;
              snap.forEach(doc => {
                console.log(doc.data().email + " started at " + doc.data().begin.toDate() + " and ended at " + doc.data().end.toDate().toDateString("DD/MM"));
                this.total += (doc.data().end.seconds - doc.data().begin.seconds) / (60*60);
                if(doc.data().end_km)
                  this.totalKm += (doc.data().end_km - doc.data().start_km);
              });
            });


    }
  },
  created()
  {
    this.start = moment().subtract(1, 'months').startOf('month').toDate();
    this.end = moment().subtract(1, 'months').endOf('month').toDate();
    //this.getUsers();
    this.getSummary();
    this.getProjects();
    
    console.log("tracker!");

    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
